import {useEffect} from "react";

export default function usePaginatorCentered(context: string, dependencies: any[], noReactTableParentClass: boolean) {

  useEffect(() => {
    let paginator = document.querySelector(`.${context} + .react-bootstrap-table-pagination`);
    if (paginator && paginator.children.length > 1) {
      let child = paginator.children[0];
      paginator.removeChild(child);
      child = paginator.children[0];
      if (child && child.hasAttribute("class")) {
        child.removeAttribute("class");
      }
      paginator.classList.remove("row");
      if (noReactTableParentClass) {
        const parent: any = document.querySelector(`.${context}`);
        parent.classList.remove("react-bootstrap-table");
      }
    }
  }, [dependencies, context, noReactTableParentClass]);

}
